import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

export const VideoItemContainer = styled.div`
  position: relative;
  padding: 16px;
  background-color: ${COLORS.canvas};
  border: 1px solid ${COLORS.border};
  border-radius: ${RADII.field};
  display: flex;
  flex-direction: column;
  height: fit-content;
`

export const VideoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`

export const VideoNumber = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.textPrimary};
`

export const PromptInputSection = styled.div`
  margin-bottom: 12px;
`

export const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 500;
  color: ${COLORS.textSecondary};
`

export const OptionsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 12px;
`

export const OptionField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ActionsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid ${COLORS.border};
`

export const GenerationOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(251, 251, 251, 0.95);
  border-radius: ${RADII.field};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`

export const ProgressContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
  width: 80%;
  max-width: 300px;
`

export const ProgressText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${COLORS.textPrimary};
  text-align: center;
`

interface IProgressBarProps {
  progress: number
}

export const ProgressBar = styled.div<IProgressBarProps>`
  width: 100%;
  height: 8px;
  background-color: ${COLORS.fillStrong};
  border-radius: 4px;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: ${props => props.progress}%;
    background: linear-gradient(
      90deg,
      ${COLORS.primary} 0%,
      ${COLORS.primaryHover} 100%
    );
    transition: width 0.3s ease;
    border-radius: 4px;
  }
`
